"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EsbBase = void 0;
const tslib_1 = require("tslib");
const Utilities_1 = require("../../../../../TdWebtoolkitControls/javascript/Utilities");
const SynView_1 = require("../../../../views/SynView");
require("../../../../../TdWebtoolkitControls/controls/Tree/Tree");
const PropertyPage_1 = require("../../../../../TdWebtoolkitControls/controls/PropertyPage/PropertyPage");
const MethodManager_1 = require("../../../../../TdWebtoolkitControls/controls/Menu/MethodManager");
const Instance_1 = require("../../../../../TdWebtoolkitControls/model/Instance");
let r_css = require("./esb.less");
let r_esbTemplate = require("./esb.tmpl.htm");
let r_esbEntryTemplate = require("./esb.entry.tmpl.htm");
let r_esbAttachmentTemplate = require("./esb.attachment.tmpl.htm");
class EsbBase extends SynView_1.SynView {
    //#endregion MEMBER VARIABLES
    //#region CONSTRUCTOR
    constructor() {
        super();
        /**
         * Maps catId --> wheter the category is currently enabled (true) in the shiftbook or filtered (false)
         */
        this.m_filterCategories = {};
        this.m_pauseRefresh = false;
    }
    getSearchTemplateAsync() {
        return Instance_1.Instance.fromSearchData({
            "cgdocument.typeid": "4500",
            "cgdocument.ownergroup": this.getOwnerGroup().toString(),
            "ceereignis.vorlage": "N",
            "cgexplorer.childs": "Y",
        });
    }
    renderContents() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let that = this;
            that.m_$container.addClass("esb");
            that.m_$tree = that.m_$container.find(".tree");
            that.m_$shiftBookPane = that.m_$container.find(".shiftBookPane");
            that.m_$shiftBook = that.m_$container.find(".shiftBook");
            that.m_$categoryList = that.m_$container.find(".categoryList");
            that.m_$categoryFilter = that.m_$container.find(".categoryFilter");
            that.m_$lookBackList = that.m_$container.find(".lookBackList");
            that.m_$templateList = that.m_$container.find(".templateList");
            that.m_$rightPane = that.m_$container.find(".synPane.rightPane");
            that.m_$choicePane = that.m_$container.find(".choicePane");
            that.m_$propPagePane = that.m_$container.find(".propPagePane");
            that.m_$attachmentList = that.m_$container.find(".attachmentList");
            that.m_$addAttachmentButton = that.m_$container.find(".addAttachmentButton");
            that.m_$newItemOptions = that.m_$container.find(".newItemOptions");
            that.m_$propertyPage = that.m_$container.find(".propertyPage");
            that.m_$buttonBar = that.m_$container.find(".buttonBar");
            that.m_$addButton = that.m_$container.find(".addItem");
            that.m_$saveButton = that.m_$container.find(".btn.save");
            that.m_$cancelButton = that.m_$container.find(".btn.cancel");
            that.m_$rightPane.kendoSplitter({
                orientation: "vertical",
                panes: [
                    { scrollable: true, collapsible: true, size: "40px" },
                    { scrollable: false, collapsible: true, size: "48px" },
                    { scrollable: false, collapsible: true, size: "30px" },
                    { scrollable: true, collapsible: true },
                    { scrollable: true, collapsible: true, collapsed: true, size: "116px", max: "116px" },
                    { scrollable: true, collapsible: true, collapsed: true, size: "50%" }
                ]
            });
            that.m_$propPagePane.kendoSplitter({
                orientation: "horizontal",
                panes: [
                    { scrollable: true, collapsible: false, },
                    { scrollable: true, collapsible: true, collapsed: false, resizable: false, size: "275px" }
                ]
            });
            yield that.m_$tree.synTree({
                rootNodeId: "27512",
                expandInitiallySelectedNode: "OnlyRootNode",
                initialSelection: "root",
            });
            let searchTemplate = yield this.getSearchTemplateAsync();
            that.m_$shiftBook.kendoListView({
                autoBind: false,
                selectable: "single",
                dataSource: new kendo.data.DataSource({
                    transport: {
                        read: function (options) {
                            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                                let lookbackListView = that.m_$lookBackList.data("kendoListView");
                                let lookbackItem = lookbackListView.dataItem(lookbackListView.select());
                                let searchTmpl = yield Instance_1.Instance.fromSearchData({
                                    "cgdocument.ceobjdate": lookbackItem.dateFilter,
                                });
                                that.m_lastFetch = new Date();
                                Utilities_1.synUtil.getAJAXData({
                                    method: "POST",
                                    url: Utilities_1.synUtil.getWSUrl("Search"),
                                    requestData: { query: JSON.stringify(searchTmpl.toJSON()) },
                                    done: function (resultsId, textStatus, jqXHR, handlerKey) {
                                        Utilities_1.synUtil.getAJAXData({
                                            method: "POST",
                                            url: Utilities_1.synUtil.getWSUrl("Results") + resultsId,
                                            headers: { "X-WS-Affinity": handlerKey },
                                            requestData: { oneShot: "true" },
                                            done: function (data) {
                                                return tslib_1.__awaiter(this, void 0, void 0, function* () {
                                                    let mapped = yield Promise.all($.map(data.data, function (item) {
                                                        return tslib_1.__awaiter(this, void 0, void 0, function* () {
                                                            let instance = yield Instance_1.Instance.fromJSON(item);
                                                            let catId = instance.items["cgdocument.typeid"].valueAsNumber;
                                                            if ($.inArray(catId, that.getEsbCategories()) < 0 || false === that.m_filterCategories[catId])
                                                                return undefined;
                                                            return instance;
                                                        });
                                                    }));
                                                    mapped.sort(function (a, b) {
                                                        let valA = a.items["cgdocument.ceobjdate"].value;
                                                        let valB = b.items["cgdocument.ceobjdate"].value;
                                                        return valA > valB ? -1 : valA === valB ? 0 : 1;
                                                    });
                                                    options.success(mapped);
                                                });
                                            }
                                        });
                                    }
                                });
                            });
                        }
                    }
                }),
                template: function (item) {
                    let tmpl = kendo.template(r_esbEntryTemplate);
                    item["synUtil"] = Utilities_1.synUtil;
                    item["kendo"] = kendo;
                    return tmpl(item);
                },
                dataBinding: function (e) {
                    let $shiftBook = that.m_$shiftBook;
                    $.each(e.items, function (idx, item) {
                        if (that.m_lastFetch !== undefined && (item["cgdocument.lastchangedate"].value - that.m_lastFetch.getTime()) > -(EsbBase.ComparisonDeltaSecondsNew * 1000))
                            item.newItem = true;
                        if (that.m_lastFetch !== undefined && (item["cgdocument.lastchangedate"].value - that.m_lastFetch.getTime()) > -(EsbBase.ComparisonDeltaSecondsRecent * 1000))
                            item.recentItem = true;
                    });
                },
                change: function () {
                    let lv = that.m_$shiftBook.data("kendoListView");
                    let $selectedItem = lv.select();
                    let selectedDataItem = lv.dataItem($selectedItem);
                    if (selectedDataItem) {
                        that.setCategoryBackgroundColor(selectedDataItem["cgdocument.typeid"].value);
                        that.m_id = selectedDataItem ? selectedDataItem.id.value : undefined;
                        that.getItem(selectedDataItem.id.value);
                        $selectedItem[0].scrollIntoView();
                    }
                }
            });
            that.m_$addAttachmentButton.on("click", () => {
                if (that.m_id)
                    MethodManager_1.MethodManager.executeMethod("cefunc.111", [], that.m_id, undefined, undefined, undefined);
            });
            that.m_$attachmentList.kendoListView({
                autoBind: false,
                template: function (item) {
                    let tmpl = kendo.template(r_esbAttachmentTemplate);
                    item["synUtil"] = Utilities_1.synUtil;
                    item["kendo"] = kendo;
                    return tmpl(item);
                },
                dataSource: new kendo.data.DataSource({
                    transport: {
                        read: function (attachmentOptions) {
                            if (that.m_id) {
                                Utilities_1.synUtil.getAJAXData({
                                    method: "POST",
                                    url: Utilities_1.synUtil.getWSUrl("Graph"),
                                    requestData: JSON.stringify({
                                        node: that.m_id,
                                        parentDepth: 0,
                                        childDepth: 1,
                                        allowedRelIDs: ["4093", "113127", "113128"],
                                        allFieldNames: true,
                                    }),
                                    done: function (data) {
                                        return tslib_1.__awaiter(this, void 0, void 0, function* () {
                                            let mapped = yield Promise.all($.map(data.nodes, function (item) {
                                                return tslib_1.__awaiter(this, void 0, void 0, function* () {
                                                    let inst = yield Instance_1.Instance.fromJSON(item.data.instance);
                                                    return inst.id.valueAsString !== that.m_id ? inst : undefined;
                                                });
                                            }));
                                            mapped.sort(function (a, b) {
                                                let valA = (a === null || a === void 0 ? void 0 : a.name.valueAsString) ? a.name.valueAsString.toLowerCase() : "";
                                                let valB = (b === null || b === void 0 ? void 0 : b.name.valueAsString) ? b.name.valueAsString.toLowerCase() : "";
                                                return valA > valB ? 1 : valA === valB ? 0 : -1;
                                            });
                                            attachmentOptions.success(mapped);
                                        });
                                    }
                                });
                            }
                            else
                                attachmentOptions.success([]);
                        }
                    }
                }),
                dataBound: function () {
                    if (this.dataSource.data().length == 0) {
                        that.m_$attachmentList.append("<div class='emptyMessage'>" + kendo.htmlEncode(Utilities_1.synUtil.Strings.getValue("listempty")) + "</div>");
                    }
                    else {
                        that.m_$attachmentList.find(".attachmentLink").click(function () {
                            let id = $(this).closest(".attachment").attr("data-id");
                            MethodManager_1.MethodManager.executeMethod("cefunc.2", [id], undefined, undefined, undefined, { newWindow: true });
                        });
                    }
                }
            });
            that.registerRefreshInterval();
            that.m_$lookBackList.kendoListView({
                selectable: "single",
                template: kendo.template("<li>${name}</li>"),
                dataBound: function () {
                    let lv = that.m_$lookBackList.data("kendoListView");
                    lv.select(that.m_$lookBackList.children().first());
                    lv.bind("change", (e) => { that.refreshShiftBook(true); });
                    that.refreshShiftBook();
                },
                dataSource: {
                    data: [
                        {
                            name: "...der letzten 3 Tage",
                            dateFilter: ">=#variable.currentdate#MINUS03-00-0000 00:00:00"
                        },
                        {
                            name: "...der letzten 7 Tage",
                            dateFilter: ">=#variable.currentdate#MINUS07-00-0000 00:00:00"
                        },
                        {
                            name: "...der letzten 14 Tage",
                            dateFilter: ">=#variable.currentdate#MINUS14-00-0000 00:00:00"
                        }
                    ]
                }
            });
            let esbCategories = that.getEsbCategories();
            that.m_$categoryList.kendoListView({
                selectable: "single",
                dataSource: new kendo.data.DataSource({
                    transport: {
                        read: function (options) {
                            let allowedPids = { "4500": true };
                            Utilities_1.synUtil.getAJAXData({
                                url: Utilities_1.synUtil.getWSUrl("GetAllCategories"),
                                done: function (data) {
                                    let categories = [];
                                    $.each(data, (idx, cat) => {
                                        if ($.inArray(cat.id, esbCategories) >= 0) {
                                            if (cat.id === 4500)
                                                categories.push(cat);
                                            else if (allowedPids[cat.parentId]) {
                                                allowedPids[cat.id] = true;
                                                categories.push(cat);
                                            }
                                        }
                                    });
                                    categories.sort((c1, c2) => {
                                        let idx1 = $.inArray(c1.id, EsbBase.EsbCategorySortOrder);
                                        let idx2 = $.inArray(c2.id, EsbBase.EsbCategorySortOrder);
                                        if (idx1 < 0) {
                                            if (idx2 < 0)
                                                return c1.name.localeCompare(c2.name);
                                            else
                                                return 1;
                                        }
                                        else if (idx2 < 0)
                                            return -1;
                                        return idx1 - idx2;
                                    });
                                    options.success(categories);
                                }
                            });
                        }
                    }
                }),
                change: function (e) {
                    if (!that.m_$categoryList.data("ignoreSelectEvent")) {
                        let clv = that.m_$categoryList.data("kendoListView");
                        let lv = that.m_$templateList.data("kendoListView");
                        let item = lv.dataItem(lv.select());
                        if (item)
                            that.m_$templateList.data("kendoListView").clearSelection();
                        let parentContext = that.getParentContext();
                        let catId = clv.dataItem(clv.select()).id;
                        that.m_$propertyPage
                            .synPropertyPage("setTemplate", {
                            mode: 4 /*New*/,
                            typeId: catId,
                            parentId: parentContext.parentId,
                            parentRelId: parentContext.parentRelId,
                        });
                        that.setCategoryBackgroundColor(catId.toString());
                    }
                },
                template: kendo.template("<div class='listElem'>#:name#</div>"),
                dataBound: function () {
                    let categories = that.m_$categoryList.data("kendoListView").dataSource.data();
                    $.each(categories, (idx, cat) => {
                        let catId = cat.id.toString();
                        that.m_filterCategories[catId] = true;
                        let $btn = $("<button></button>")
                            .attr({
                            "type": "button",
                            "data-toggle": "button",
                            "aria-pressed": "true",
                            "data-catid": catId
                        })
                            .click(function () {
                            that.m_filterCategories[$(this).attr("data-catid")] = !$(this).hasClass("active");
                            that.refreshShiftBook(true);
                        })
                            .text(cat.name)
                            .addClass("btn btn-primary active cat_" + catId)
                            .appendTo(that.m_$categoryFilter);
                        $btn.prepend($("<img class='catIcon' src='" + Utilities_1.synUtil.getWSUrl("Icon") + cat.icon + "/16" + "' alt='" + cat.name + "' />"));
                    });
                }
            });
            that.m_$templateList.kendoListView({
                selectable: "single",
                dataSource: new kendo.data.DataSource({
                    transport: {
                        read: function (options) {
                            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                                let searchTemplateTmpl = searchTemplate.clone();
                                yield searchTemplateTmpl.addSearchField("ceereignis.vorlage", "Y");
                                Utilities_1.synUtil.getAJAXData({
                                    method: "POST",
                                    url: Utilities_1.synUtil.getWSUrl("Search"),
                                    requestData: { query: JSON.stringify(searchTemplateTmpl.toJSON()) },
                                    done: function (resultsId, textStatus, jqXHR, handlerKey) {
                                        Utilities_1.synUtil.getAJAXData({
                                            method: "POST",
                                            url: Utilities_1.synUtil.getWSUrl("Results") + resultsId,
                                            headers: { "X-WS-Affinity": handlerKey },
                                            requestData: {
                                                oneShot: "true",
                                            },
                                            done: function (data) {
                                                return tslib_1.__awaiter(this, void 0, void 0, function* () {
                                                    let mapped = yield Promise.all($.map(data.data, function (item) {
                                                        return Instance_1.Instance.fromJSON(item);
                                                    }));
                                                    mapped.sort(function (a, b) {
                                                        let valA = a.name.valueAsString ? a.name.valueAsString.toLowerCase() : "";
                                                        let valB = b.name.valueAsString ? b.name.valueAsString.toLowerCase() : "";
                                                        return valA > valB ? 1 : valA === valB ? 0 : -1;
                                                    });
                                                    options.success(mapped);
                                                });
                                            }
                                        });
                                    }
                                });
                            });
                        }
                    }
                }),
                change: function (e) {
                    let lv = that.m_$templateList.data("kendoListView");
                    let item = lv.dataItem(lv.select());
                    if (item) {
                        let changeCategorySelection = false;
                        let clv = that.m_$categoryList.data("kendoListView");
                        let catId = item.items["cgdocument.typeid"].valueAsString;
                        let selectedCategory = clv.dataItem(clv.select());
                        if (selectedCategory)
                            changeCategorySelection = selectedCategory.id.toString() !== catId;
                        else
                            changeCategorySelection = true;
                        that.m_$categoryList.data("ignoreSelectEvent", true);
                        if (changeCategorySelection)
                            if (!that.trySelectCategory(catId))
                                clv.clearSelection();
                        that.m_$categoryList.data("ignoreSelectEvent", undefined);
                        that.setCategoryBackgroundColor(catId);
                        that.applyTemplate(item);
                    }
                },
                template: kendo.template("<div class='listElem'>#:name.value#</div>"),
                dataBound: function () {
                }
            });
            that.m_$addButton.click(function () {
                that.newItem();
            });
            that.m_$saveButton.click(function () {
                that.commit();
            });
            that.m_$cancelButton.click(function () {
                that.showPropertyPage(false);
                that.m_$shiftBook.data("kendoListView").clearSelection();
            });
        });
    }
    //#endregion Inherited from SynView
    //#region Helpers
    setCategoryBackgroundColor(catId) {
        let that = this;
        let removeCatClasses = function ($pane) {
            let cssClasses = $pane.attr('class').split(" ");
            $.each(cssClasses, (idx, cssClass) => {
                if (cssClass.indexOf("cat_") === 0)
                    $pane.removeClass(cssClass);
            });
        };
        let catClass = "cat_" + catId;
        removeCatClasses(that.m_$propPagePane);
        removeCatClasses(that.m_$choicePane);
        that.m_$propPagePane.addClass(catClass);
        that.m_$choicePane.addClass(catClass);
    }
    applyTemplate(template) {
        let parentContext = this.getParentContext();
        this.m_$propertyPage
            .one("instanceReceived", function (evt, instance) {
            instance.items["cgdocument.doclabel"].value = template.items["cgdocument.doclabel"].value;
        })
            .synPropertyPage("setTemplate", {
            mode: 4 /*New*/,
            typeId: parseInt(template.id.valueAsString.split("|")[2], 10),
            parentId: parentContext.parentId,
            parentRelId: parentContext.parentRelId
        });
    }
    trySelectCategory(catId) {
        let catIdx = -1;
        let clv = this.m_$categoryList.data("kendoListView");
        $.each(clv.dataSource.data(), (idx, cat) => {
            if (cat.id.toString() == catId) {
                catIdx = idx;
                return false;
            }
        });
        if (catIdx >= 0) {
            let $item = $(this.m_$categoryList.find(".listElem")[catIdx]);
            clv.select($item);
            return true;
        }
        return false;
    }
    newItem() {
        let that = this;
        that.showPropertyPage(true);
        that.m_$attachmentList.hide();
        that.m_$newItemOptions.show();
        let propPageSplitter = that.m_$propPagePane.data("kendoSplitter");
        propPageSplitter.collapse(".attachmentPane");
        let splitter = that.m_$rightPane.data("kendoSplitter");
        splitter.collapse(".shiftBookPane");
        that.m_$shiftBookPane.css("overflow", "");
        splitter.size(".choicePane", splitter.options.panes[4].max);
        that.createPropertyPage(() => {
            let clv = that.m_$categoryList.data("kendoListView");
            that.trySelectCategory("4500");
        });
    }
    getParentContext() {
        let id = this.m_$tree.synTree("getSelectedId");
        if (id)
            return { parentId: id, parentRelId: 113135, };
        return { parentId: undefined, parentRelId: 0 };
    }
    getItem(id) {
        let that = this;
        that.showPropertyPage(true);
        that.m_$newItemOptions.hide();
        that.m_$attachmentList.show();
        that.m_$attachmentList.data("kendoListView").dataSource.read();
        let propPageSplitter = that.m_$propPagePane.data("kendoSplitter");
        propPageSplitter.expand(".attachmentPane");
        let splitter = that.m_$rightPane.data("kendoSplitter");
        let selectedItemHeight = that.m_$shiftBook.data("kendoListView").select().outerHeight(false);
        splitter.size(".shiftBookPane", selectedItemHeight + "px");
        that.m_$shiftBookPane.css("overflow", "hidden");
        splitter.size(".choicePane", that.m_$buttonBar.outerHeight(true) + "px");
        that.createPropertyPage(() => {
            that.m_$propertyPage
                .synPropertyPage("setInstance", {
                mode: 3 /*Edit*/,
                id: id
            });
        });
    }
    createPropertyPage(callback = undefined) {
        let that = this;
        if (that.m_$propertyPage.synPropertyPage)
            that.m_$propertyPage.off("valuesChanged").off("valuesReverted").synPropertyPage("destroy");
        that.m_$propertyPage
            .on("modifyInstanceBeforeCommit", (evt, instance) => {
            instance.items["cgdocument.ownergroup"].value = that.getOwnerGroup().toString();
        })
            .on("endInit", () => {
            if (callback)
                callback();
        })
            .synPropertyPage();
    }
    showPropertyPage(show) {
        if (show) {
            this.m_$rightPane.data("kendoSplitter").collapse(".addPane");
            this.m_$rightPane.data("kendoSplitter").collapse(".filterPane");
            this.m_$rightPane.data("kendoSplitter").collapse(".lookbackPane");
            this.m_$rightPane.data("kendoSplitter").expand(".choicePane");
            this.m_$rightPane.data("kendoSplitter").expand(".propPagePane");
            this.m_pauseRefresh = true;
        }
        else {
            this.m_$rightPane.data("kendoSplitter").expand(".addPane");
            this.m_$rightPane.data("kendoSplitter").expand(".filterPane");
            this.m_$rightPane.data("kendoSplitter").expand(".lookbackPane");
            this.m_$rightPane.data("kendoSplitter").collapse(".choicePane");
            this.m_$rightPane.data("kendoSplitter").expand(".shiftBookPane");
            this.m_$rightPane.data("kendoSplitter").collapse(".propPagePane");
            this.m_$propertyPage.synPropertyPage("destroy");
            this.m_pauseRefresh = false;
            this.m_$shiftBookPane.scrollTop(0);
        }
    }
    commit() {
        let that = this;
        Utilities_1.synUtil.beginAjaxProgress(that.m_$saveButton);
        that.m_$propertyPage.synPropertyPage("commitChanges", {
            success: (_, result) => {
                if (result === PropertyPage_1.CommitSuccess.NoChanges)
                    Utilities_1.synUtil.Notifications.warning(Utilities_1.synUtil.Strings.getValue("nochanges"));
                that.showPropertyPage(false);
                that.refreshShiftBook(true);
            },
            cleanUp: () => { Utilities_1.synUtil.endAjaxProgress(that.m_$saveButton); }
        });
    }
    registerRefreshInterval() {
        let that = this;
        that.clearRefreshInterval();
        that.m_refreshTimerId = window.setInterval(that.refreshShiftBook.bind(that), EsbBase.RefreshIntervalSeconds * 1000);
    }
    clearRefreshInterval() {
        window.clearInterval(this.m_refreshTimerId);
    }
    refreshShiftBook(force = false) {
        let that = this;
        if (force || !that.m_pauseRefresh && (!that.m_lastFetch || (new Date().getTime() - that.m_lastFetch.getTime() > EsbBase.RefreshIntervalSeconds * 500))) {
            that.m_$shiftBook.data("kendoListView").dataSource.read();
        }
    }
    forceRefresh(modificationInfo) {
    }
}
exports.EsbBase = EsbBase;
//#region MEMBER VARIABLES
EsbBase.EsbCategorySortOrder = [4500, 4560, 4570, 4550, 4510, 4575, 4520, 4530, 4540];
/**
 * Refresh interval for shift book in seconds
 */
EsbBase.RefreshIntervalSeconds = 60;
/**
 * If difference between lastFetch time and lastchangedate < ComparisonDeltaSecondsNew, the document is considered "new"
 */
EsbBase.ComparisonDeltaSecondsNew = 10;
/**
 * If difference between lastFetch time and lastchangedate < ComparisonDeltaSecondsRecent, the document is considered "recent"
 */
EsbBase.ComparisonDeltaSecondsRecent = 120;
